import { BpArticle } from '../../../../shared/components/cards/article/BpArticle'
import React from 'react'

interface AdCellProps {
  title: string
  text: string
  domain: string
}

export const AdCell = ({ title, text, domain }: AdCellProps) => {
  return <BpArticle link={domain} text={text} title={title} />
}
